<template>
  <el-dialog
    title="Сопроводительный паспорт"
    :visible="passportDate !== null"
    width="55%"
    append-to-body
    destroy-on-close
    @close="passportDate = null"
  >
    <disposal-pasport-form
      v-if="passportDate"
      :action="passport"
      :waste="passportWastes"
      @addPasportToTable="onPassport"
    ></disposal-pasport-form>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import DisposalPasportForm from "@/components/ecologist/disposal/disposalPasport";
import { emptyPassport } from "./entryModes";

// Сопроводительный паспорт строки таблицы этапа: open(date) открывает его, заполненный пишется в поля строки
export default {
  name: "passportDialog",
  components: { DisposalPasportForm },
  props: {
    // Режим или действие, в поля строк которого пишется паспорт
    type: { type: String, default: null },
  },
  data() {
    return {
      passportDate: null,
      passport: null,
      // Отход для полей тары в форме паспорта (только у передачи контрагенту)
      passportWastes: null,
    };
  },

  computed: {
    ...mapState("wasteEntry", ["waste", "dates", "lastPassportDate"]),
    values() {
      return this.$store.state.wasteEntry.values[this.type] || {};
    },
  },

  methods: {
    /*
      Номер нового паспорта: на 1 больше самого большого в этой записи
      (у передачи контрагенту - среди паспортов того же года) и не меньше следующего свободного
      на сервере. Номер в форме можно изменить - при сохранении он не перезаписывается
    */
    nextPassportNumber(date, contractor, serverNext) {
      const year = date.slice(0, 4);
      const numbers = this.dates
        .filter((other) => !contractor || other.slice(0, 4) === year)
        .map((other) => (this.values[other] || {}).passport)
        .filter((passport) => passport && passport.number != null)
        .map((passport) => Number(passport.number));
      return Math.max(Number(serverNext) || 1, ...numbers.map((n) => n + 1));
    },

    // Как в «Вывозе отходов»: следующий паспорт - копия последнего заполненного с номером +1
    async open(date) {
      const [y, m, d] = date.split("-");
      const contractor = this.type === "contractor";
      // Передача контрагенту нумерует паспорта по году, как «Вывоз отходов»
      const info = contractor
        ? await this.$store.dispatch("GetNumberPassportYear", y)
        : await this.$store.dispatch("GetNumberPassport");
      const last = this.lastPassportDate
        ? this.values[this.lastPassportDate] || {}
        : {};
      const passport = last.passport
        ? JSON.parse(JSON.stringify(last.passport))
        : Object.assign(emptyPassport(), {
            egr_full_name: info.egr_full_name,
            contractor1r: info.egr_full_name,
            contractor2r: info.egr_full_name,
            contractor3r: info.egr_full_name,
          });
      Object.assign(passport, {
        number: this.nextPassportNumber(date, contractor, info.numb),
        data: `${d}.${m}.${y}`,
      });
      this.passportWastes = null;
      if (contractor) {
        // Как в accompanyingPassport: получатель и перевозчик - выбранный контрагент
        const values = this.values[date] || {};
        const contractorId = values.Contractors ? values.Contractors.id : null;
        Object.assign(passport, {
          ca2: "Контрагент",
          ca3: "Контрагент",
          contractor2: contractorId,
          contractor3: contractorId,
          contractor2r: null,
          contractor3r: info.egr_full_name,
        });
        if (values.receivedFromPerson)
          Object.assign(passport, {
            ca2: "Ручной ввод",
            contractor2r: "Физическое лицо",
          });
        // Тара строки, а если её ещё нет - из последнего заполненного паспорта
        const [code, ...name] = this.waste.name.split("-");
        this.passportWastes = [
          {
            ss01DictionaryId: this.waste.organizationWasteId,
            wasteCode: code,
            wasteName: name.join("-"),
            tara_name: values.taraName || last.taraName || null,
            tara_vight: values.taraWeight || last.taraWeight || null,
          },
        ];
      }
      this.passport = passport;
      this.passportDate = date;
    },

    onPassport(passport, psId, wastes) {
      const date = this.passportDate;
      const row = { ...this.values[date], passport };
      if (wastes && wastes[0])
        Object.assign(row, {
          taraName: wastes[0].tara_name,
          taraWeight: wastes[0].tara_vight,
        });
      this.$store.commit("wasteEntry/setValues", {
        type: this.type,
        values: { ...this.values, [date]: row },
      });
      this.$store.commit("wasteEntry/setLastPassportDate", date);
      this.passportDate = null;
    },
  },
};
</script>
